"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _recompose = require("../recompose");
var _styled = require("../styled");
var masterFirst = function masterFirst(groupKey) {
  return function (a, b) {
    if ((0, _styled.prop)(groupKey)(a) === a.id) {
      return -1;
    } else if ((0, _styled.prop)(groupKey)(b) === b.id) {
      return 1;
    }
    return 0;
  };
};
var withGrouping = function withGrouping(groupKey) {
  return (0, _recompose.withProps)(function (_ref) {
    var items = _ref.items;
    var groups = (0, _groupBy.default)(items, groupKey);
    var masters = Object.keys(groups).map(function (k) {
      return groups[k];
    });
    masters.forEach(function (variants) {
      return variants.sort(masterFirst(groupKey));
    });
    return {
      items: masters.map(function (variants) {
        return variants[0];
      })
    };
  });
};
var _default = exports.default = withGrouping;